import { useOs } from "@mantine/hooks";
import { useEffect } from "react";

/**
 * Hook to reset zoom level on iOS devices when orientation changes
 * This prevents the zoom level from being maintained during orientation changes
 */
export function useOrientationAdjust() {
	const os = useOs();

	useEffect(() => {
		if (os === "ios" && document.querySelector) {
			const rotateWithNoScale = () => {
				const viewport = document.querySelector("meta[name=viewport]");
				if (viewport) {
					const content = viewport.getAttribute("content") || "";
					viewport.setAttribute("content", `${content}, maximum-scale=1.0`);
					setTimeout(() => {
						viewport.setAttribute("content", content);
					}, 90);
				}
			};

			window.addEventListener("orientationchange", rotateWithNoScale, false);

			// Cleanup function to remove event listener when component unmounts
			return () => {
				window.removeEventListener(
					"orientationchange",
					rotateWithNoScale,
					false,
				);
			};
		}
	}, [os]);
}
